'use client';
import React, { useEffect, useState } from 'react';
import Link from 'next/link';
import { useAppSelector } from '@/lib/redux/hooks';
import { toast } from 'react-toastify';
import NextImage from '@/features/Image';
import axios from '@/lib/axios';

const OrderSummary = ({
  cartSummary,
  register,
  watch,
  mutate,
  isSubmitting,
}: any) => {
  const selectedPayment = watch('payment_type');
  const cartItems = useAppSelector((state) => state.cart.items);
  const [coupon, setCoupon] = useState(cartSummary?.coupon_code);
  const [firstRender, setFirstRender] = useState(false);

  const handleAddCoupon = async () => {
    try {
      const res = await axios.post(`/api/v2/coupon-apply/on-cart`, {
        coupon_code: coupon,
      });
      if (res.data?.result) {
        toast.success(res?.data?.message);
        mutate();
      } else {
        toast.error(res?.data?.message);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const handleRemoveCoupon = async () => {
    try {
      const res = await axios.post(`/api/v2/coupon-remove`, {
        coupon_code: coupon,
      });
      if (res.data?.result) {
        toast.info(res?.data?.message);
        mutate();
        setCoupon('');
      } else {
        toast.error(res?.data?.message);
      }
    } catch (error) {
      console.log(error);
    }
  };

    useEffect(() => {
    if (firstRender && cartItems?.length > 0) {
      mutate();
    } else {
      setTimeout(() => {
        setFirstRender(true);
      }, 1000);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [cartItems, firstRender]);


  return (
    <div className="col-lg-5">
      <div
        className="order"
        data-aos="fade-left"
        data-aos-duration={800}
        data-aos-delay={100}
      >
        <div className="checkout__title">
          <h5>Order Summary</h5>
        </div>
        <div className="order__details table-responsive">
          <table className="table">
            <tbody>
              {cartItems.map((item, i) => (
                <tr key={i}>
                  <td colSpan={2}>
                    <table className="table table-borderless">
                      <tbody>
                        <tr>
                          <td>
                            <div className="o-info">
                              <NextImage
                                src={item.product_thumbnail_image || ''}
                                alt={'Cart image'}
                                width={90}
                                height={90}
                                aspectRatio="1/1"
                                style={{
                                  objectFit: 'cover',
                                  borderRadius: '4px',
                                }}
                              />

                              <div className="o-details">
                                <Link href={`/product/${item?.slug}`}>
                                  {item.product_name.slice(0, 25)}
                                  {item.product_name.length > 25 ? '...' : ''}
                                  <div>
                                    {item.quantity} x ৳{item.price}
                                  </div>
                                </Link>
                              </div>
                            </div>
                          </td>
                          <td>
                            ৳
                            {(
                              Number(item.price) * Number(item.quantity)
                            ).toFixed(2)}
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </td>
                </tr>
              ))}

              <tr>
                <th scope="row" className="text-muted">
                  Sub Total
                </th>
                <td>{cartSummary?.sub_total}</td>
              </tr>

              <tr>
                <th scope="row" className="text-muted">
                  Shipping
                </th>
                <td>{cartSummary?.shipping_cost}</td>
              </tr>
              <tr>
                <th scope="row" className="text-muted">
                  Discount
                </th>
                <td>{cartSummary?.discount}</td>
              </tr>
            </tbody>
            <tfoot>
              <tr>
                <th>
                  <h4 className="fw-medium mb-0">Total ( TK ) </h4>
                  {/* <span className="fw-normal mb-0">
                    VAT included, where applicable
                  </span> */}
                </th>
                <td>
                  <h4 className="fw-medium mb-0">{cartSummary?.grand_total}</h4>
                </td>
              </tr>

              {cartSummary?.coupon_code ? (
                <tr>
                  <th scope="row" className="text-muted">
                    <input
                      placeholder="Coupon"
                      className="form-control"
                      type="text"
                      value={coupon}
                      onChange={(e) => setCoupon(e.target?.value)}
                      readOnly={true}
                    />
                  </th>
                  <td>
                    <button
                      type="button"
                      onClick={handleRemoveCoupon}
                      className="trk-btn trk-btn--secondary "
                    >
                      Remove
                    </button>
                  </td>
                </tr>
              ) : (
                <tr className="py-5">
                  <th scope="row" className="text-muted">
                    <input
                      placeholder="Coupon"
                      className="form-control"
                      type="text"
                      value={coupon}
                      onChange={(e) => setCoupon(e.target?.value)}
                    />
                  </th>
                  <td className="ps-2">
                    <button
                      type="button"
                      onClick={handleAddCoupon}
                      className="form-control text-white bg-dark fw-semibold"
                    >
                      Apply
                    </button>
                  </td>
                </tr>
              )}
            </tfoot>
          </table>
        </div>
        <div className="order__option">
          <div className="order__option-title">
            <p>Payment</p>
          </div>

          <div className="order__option-item">
            <div className="form-radio-wrapper">
              <input
                className="form-radio"
                type="radio"
                value="ssl"
                id="card"
                {...register('payment_type')}
                checked={selectedPayment === 'ssl'}
              />
              <label className="form-check-label" htmlFor="card">
                Online Payment
              </label>
            </div>
            <div className="thumb">
              <NextImage
                width={100}
                height={40}
                src="/images/payments/online.png"
                alt="payment icon"
              />
              {/* <NextImage
                width={52}
                height={24}
                src="/images/payment/visa_card.png"
                alt="payment icon"
              /> */}
            </div>
          </div>

          <div className="order__option-item">
            <div className="form-radio-wrapper">
              <input
                className="form-radio"
                type="radio"
                value="bkash"
                id="bkash"
                {...register('payment_type')}
                checked={selectedPayment === 'bkash'}
              />
              <label className="form-check-label" htmlFor="bkash">
                bkash
              </label>
            </div>
            <div className="thumb">
              <NextImage
                width={100}
                height={40}
                src="/images/payments/bkash_new.png"
                alt="payment icon"
              />
            </div>
          </div>

          <div className="order__option-item">
            <div className="form-radio-wrapper">
              <input
                className="form-radio"
                type="radio"
                value="cash_on_delivery"
                id="cash"
                {...register('payment_type')}
                checked={selectedPayment === 'cash_on_delivery'}
              />
              <label className="form-check-label" htmlFor="cash">
                Cash on Delivery
              </label>
            </div>
            <div className="thumb">
              <NextImage
                width={100}
                height={40}
                src="/images/payments/cash-on-delivery.png"
                alt="payment icon"
              />
            </div>
          </div>
        </div>
        {/* <div className="order__check mt-5">
          <div className="form-check">
            <input
              className="form-check-input"
              type="checkbox"
              checked={accepted}
              onChange={(e) => setAccepted(e.target.checked)} // 👈 update state
              id="data"
            />
            <label className="form-check-label" htmlFor="data">
              Your personal data will be used to process your order, support
              experience throughout this website, and for other purposes
              described in our privacy policy.
            </label>
          </div>
        </div> */}
        <button type="submit" className="trk-btn trk-btn--primary d-block mt-4">
          {!isSubmitting ? 'Place Order' : 'Loading...'}
        </button>
      </div>
    </div>
  );
};

export default OrderSummary;
